/* eslint-disable arrow-parens */
import React, { useMemo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { SurveyToast } from '@xiam/xiam-ui-toolkit'
import { getFirstName } from '../../../../helpers/users'
import '../../../../utils/i18n';

// store
import { getUserObject } from '../../../../store/selectors/userProfile'

// constants
import MenuItems from '../../../../constants/menuItems'

// components
import MenuItem from './components/menuItem'
import WelcomeBanner from './components/welcomeBanner'
import LoadingSpinner from '../../../../components/loadingSpinner'
import { useIsMobileView } from '../../../../utils/isMobileView'
import {
  fetchSurveyTemplates,
  selectSurveyTemplateByTag,
  selectSurveyTemplates,
} from '../../../../store/reducers/surveyTemplateSlice'
import {
  resetSurveyResponses,
  setSurveyResponses,
  setIsSurveySubmitted,
  setCurrentPage,
  submitSurveyResponse,
} from '../../../../store/reducers/surveySlice'
import { SURVEY_TEMPLATE_TAG_HOME } from '../../../../utils/config'
import { getUserId, isReviewer } from '../../../../helpers/user';
import { fetchReviews, fetchOpenCampiagn, fetchClosedCampiagn } from '../../../../store/actions/reviews';

function Dashboard() {
  const userData = useSelector(getUserObject)
  const userId = getUserId()
  const menu = MenuItems()
  const dispatch = useDispatch()
  const isMobileView = useIsMobileView()

  const surveySchema = useSelector(
    selectSurveyTemplateByTag(SURVEY_TEMPLATE_TAG_HOME),
  )
  const surveyTemplate = useSelector(selectSurveyTemplates)

  const buttonColors = useMemo(() => ['green', '#D7AD01', 'red'], [])
  const [isSnackbarOpen, setSnackbarOpen] = useState(false)
  const surveyResponses = useSelector(state => state.survey.surveyResponses)
  const currentPage = useSelector(state => state.survey.currentPage)
  const isSurveySubmitted = useSelector(state => state.survey.isSurveySubmitted)

  const { i18n } = useTranslation()
  const preferredLanguage = i18n?.resolvedLanguage ?? 'en-US';

  const [localResponses, setLocalResponses] = useState(surveyResponses)

  const templateId = surveySchema?.template_id

  const [isModalOpen, setModalOpen] = useState(false)

  const onCloseReset = () => {
    dispatch(setIsSurveySubmitted(false))
    dispatch(resetSurveyResponses())
    dispatch(setCurrentPage(0))
    setLocalResponses({})
  }

  useEffect(() => {
    dispatch(fetchSurveyTemplates())
  }, [dispatch])

  if (isReviewer()) {
    useEffect(() => {
        dispatch(fetchReviews(userId))
        dispatch(fetchOpenCampiagn())
        dispatch(fetchClosedCampiagn())
    }, [dispatch])
  }

  const handleSurveyChange = newResponses => {
    dispatch(setSurveyResponses(newResponses))
  }

  const handleAnswerChange = (questionId, answer) => {
    const updatedResponses = { ...localResponses, [questionId]: answer }
    setLocalResponses(updatedResponses)
    handleSurveyChange(updatedResponses)
  }

  const handleCurrentPageChange = newPage => {
    dispatch(setCurrentPage(newPage))
  }

  if (getFirstName(userData) === '') {
    return <LoadingSpinner />
  }

  const handleSurveySubmit = (formattedSurveyResponse) => {
    if (!templateId) return

    dispatch(
      submitSurveyResponse({
        id: templateId,
        responses: formattedSurveyResponse,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(setIsSurveySubmitted(true))
        dispatch(resetSurveyResponses())
        setSnackbarOpen(false)
      })
  }

  return (
    <div
      style={{
        backgroundColor: '#E8E6E3',
        minHeight: '100vh',
        width: '100vw',
      }}
    >
      <WelcomeBanner />
      <div
        style={{
          backgroundColor: '#E8E6E3',
          width: isMobileView ? '100%' : '90%',
          paddingLeft: '0',
          paddingRight: '0',
          paddingTop: '15px',
          marginTop: '23px',
          paddingBottom: '100px',
          marginLeft: isMobileView ? '0' : '130px',
          display: 'flex',
          justifyContent: isMobileView ? 'center' : 'left',
          alignItems: isMobileView ? 'center' : 'stretch',
          overflow: 'hidden',
          flexWrap: 'wrap',
        }}
      >
        {menu.map((menuItem) => (
          <MenuItem menuItem={menuItem} key={menuItem.id} />
        ))}
        <div>
          {surveySchema && (
            <SurveyToast
              isSnackbarOpen={isSnackbarOpen}
              setSnackbarOpen={setSnackbarOpen}
              modalOpen={isModalOpen}
              setModalOpen={setModalOpen}
              buttonColors={buttonColors}
              isDelayed
              surveyResponses={surveyResponses}
              setSurveyResponses={setSurveyResponses}
              surveyTemplate={surveyTemplate}
              SURVEY_TEMPLATE_TAG={SURVEY_TEMPLATE_TAG_HOME}
              preferredLanguage={preferredLanguage}
              responses={localResponses}
              handleAnswerChange={handleAnswerChange}
              handleSubmit={handleSurveySubmit}
              handleCurrentPageChange={handleCurrentPageChange}
              currentPage={currentPage}
              onCloseReset={onCloseReset}
              isSurveySubmitted={isSurveySubmitted}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Dashboard
